import {
  START_LOADER,
  STOP_LOADER,
  SHOW_SIDEBAR,
  HIDE_SIDEBAR,
  SHOW_TIME_EXPIRED_MODAL,
  HIDE_TIME_EXPIRED_MODAL,
  SIDEBAR_UNFOLD,
  SIDEBAR_FOLD,
} from "../constants/actionTypes";
let defaultState = {
  isLoading: false,
  sidebarShow: true,
  unfoldable: true,
  sidebarUnfoldable: false,
};
export default (state = defaultState, action) => {
  switch (action.type) {
    case START_LOADER:
      return { ...state, isLoading: true };
    case STOP_LOADER:
      return { ...state, isLoading: false };
    case SHOW_SIDEBAR:
      return { ...state, sidebarShow: true, unfoldable: false };
    case HIDE_SIDEBAR:
      return { ...state, sidebarShow: false, unfoldable: true };
    case SHOW_TIME_EXPIRED_MODAL:
      return { ...state, sidebarShow: true, showModal: true };
    case HIDE_TIME_EXPIRED_MODAL:
      return { ...state, sidebarShow: false, showModal: false };
    case SIDEBAR_UNFOLD:
      return { ...state, sidebarUnfoldable: true };
    case SIDEBAR_FOLD:
      return { ...state, sidebarUnfoldable: false };
    default:
      return state;
  }
};
